@if (SimConfigurationService.settings.environmentOverlayEnabled && !!info()) {
	<div
		class="environment-overlay"
		[ngStyle]="{'background-color': color}"
	>
		<div class="environment">{{ SimConfigurationService.settings.environmentName }}</div>
		<div class="version">{{ version() }}</div>
		<div class="version">{{ window.electron ? "Electron" : "Browser" }}</div>
		@if (extendedInfoEnabled()) {
			<div class="version">DeviceId: {{ deviceId() || "-" }}</div>
			<div class="version">AutoLoginCapability: {{ autoLoginCapability() || "-" }}</div>
			<div class="version">RoomName: {{ roomName() || "-" }}</div>
		}
	</div>
}
